import { useQsFilters } from "@dash/filters";

import { Serializers } from "@megaron/serializers";
import { priorities, ticketStatuses } from "@megaron/support-contracts";
import type { Priority, TicketStatus } from "@megaron/support-contracts";

export type SupportTicketsSortField = "createdAt" | "updatedAt" | "priority";
export type SupportTicketsSortOrder = "ASC" | "DESC";
export type SupportTicketsSortValue = {
  field: SupportTicketsSortField;
  order: SupportTicketsSortOrder;
};

export type SupportTicketsFiltersType = {
  page?: number;
  searchText?: string;
  status?: TicketStatus[];
  priority?: Priority[];
  tags?: string[];
  sort?: SupportTicketsSortField;
  sortOrder?: SupportTicketsSortOrder;
  myTickets?: boolean;
  isRead?: boolean;
};

const supportTicketsFiltersSerializer = Serializers.object({
  page: Serializers.integer.optional(),
  searchText: Serializers.string.optional(),
  status: Serializers.stringOneOf(...ticketStatuses).array().asJsonString().optional(),
  priority: Serializers.stringOneOf(...priorities).array().asJsonString().optional(),
  tags: Serializers.string.array().asJsonString().optional(),
  sort: Serializers.stringOneOf("createdAt", "updatedAt", "priority").optional(),
  sortOrder: Serializers.stringOneOf("ASC", "DESC").optional(),
  myTickets: Serializers.boolean.optional(),
  isRead: Serializers.boolean.optional(),
}).partial();

const defaultActiveStatuses: TicketStatus[] = ticketStatuses.filter(
  (s): s is TicketStatus => s !== "resolved" && s !== "closed",
);

const defaultFilters: SupportTicketsFiltersType = {
  page: 0,
  searchText: "",
  status: defaultActiveStatuses,
  priority: [],
  tags: [],
  sort: "updatedAt",
  sortOrder: "DESC",
  myTickets: undefined,
  isRead: undefined,
};

export const useSupportTicketsFilters = () => {
  const { filters, setFilters, setFilter } = useQsFilters<SupportTicketsFiltersType>(
    supportTicketsFiltersSerializer,
    defaultFilters,
    "filters",
  );

  return { filters, setFilter, setFilters, defaultFilters };
};
